import React from 'react';
import ReactMarkdown from 'react-markdown';
import styles from './styles.module.scss';

import { spanish } from '../../config/config';

const Markdown = ({ data }) => (
  <div className={styles.container}>
    <h2>{spanish ? data?.TitleSpanish : data?.TitleEnglish}</h2>
    <div className={styles.content}>
      <ReactMarkdown
        children={spanish ? data?.ContentSpanish : data?.ContentEnglish}
      />
    </div>
  </div>
);

export default Markdown;
